var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgR7ShareIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.00001 11.2L8.00001 1.20001M8.00001 1.20001L11.2 4.00001M8.00001 1.20001L4.80001 4.00001",
  stroke: "currentColor",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 6.99811H12C12.8837 6.99811 13.6 7.71445 13.6 8.59811V13.2C13.6 14.0837 12.8837 14.8 12 14.8H4.00002C3.11637 14.8 2.40002 14.0837 2.40002 13.2V8.59811C2.40002 7.71445 3.11637 6.99811 4.00002 6.99811H4.9997",
  stroke: "currentColor",
  strokeWidth: 0.9,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgR7ShareIcon as ReactComponent };